import { ConnectedChecklists } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components";
import { PendingChecklists } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/InterventionChecklists.scss";

import type { Appointment, CarCheck, Checklist, Intervention } from "models";

type InterventionChecklistPropTypes = {
  connectedChecks: CarCheck[];
  intervention: Intervention;
  checklists?: Checklist[];
  appointment?: Appointment;
};

export const InterventionChecklists = ({ connectedChecks, intervention, checklists, appointment }: InterventionChecklistPropTypes) => (
  <>
    <ConnectedChecklists connectedChecks={connectedChecks} />
    <PendingChecklists intervention={intervention} offset={connectedChecks.length} checklists={checklists} appointment={appointment} />
  </>
);
